import { canAccessSalesProposalDealWorkspace } from "./proposalPublicRoutes";

/** Customer-facing proposal PDF download button label (Link B). */
export const PROPOSAL_PDF_DOWNLOAD_LABEL_CUSTOMER = "Download Proposal PDF";

/** Staff Link A preview — same PDF output, no customer engagement tracking. */
export const PROPOSAL_PDF_DOWNLOAD_LABEL_STAFF = "Download PDF Version";

/**
 * When true, opening print / PDF must not call Link B engagement mutations
 * (view count, PDF download timeline, comm logs, reminders, PIC signals).
 */
export function shouldSkipProposalCustomerEngagementTracking(input: {
  audience?: "customer" | "staff";
  approvalDisabled?: boolean;
  isSandbox?: boolean;
}): boolean {
  if (input.isSandbox) return true;
  if (input.audience === "staff") return true;
  if (input.approvalDisabled) return true;
  return false;
}

export function proposalPdfDownloadLabel(input: {
  audience?: "customer" | "staff";
  approvalDisabled?: boolean;
  isSandbox?: boolean;
}): string {
  return shouldSkipProposalCustomerEngagementTracking(input)
    ? PROPOSAL_PDF_DOWNLOAD_LABEL_STAFF
    : PROPOSAL_PDF_DOWNLOAD_LABEL_CUSTOMER;
}

/** Server guard: authenticated sales/finance/admin must not pollute Link B engagement metrics. */
export function shouldSkipProposalCustomerEngagementForUser(
  user: { role?: string | null } | null | undefined,
): boolean {
  return canAccessSalesProposalDealWorkspace(user?.role);
}
